"use client"

import { redirect } from "next/navigation"
import { ROUTES } from "@/consts"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@instadeepai/fontawesome-pro-regular"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
  IconButton,
} from "@shared/ui"

import { Module } from "../types"
import { EmptyModules } from "./empty-modules"
import { ModuleCard } from "./module-card"
import { ModuleDetails } from "./module-details"

interface ModulesContentProps {
  filteredModules: Module[]
}

export const ModulesContent = ({ filteredModules }: ModulesContentProps) => {
  const handleForgeWithModule = (module: Module) => {
    redirect(
      `${ROUTES.SELECT_MODULE}?selectedModule=${module.id}&showConfig=true`
    )
  }

  if (filteredModules.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <EmptyModules />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(328px,1fr))] gap-6 py-6">
      {filteredModules.map((module) => (
        <Dialog key={module.id}>
          <DialogTrigger asChild>
            <div>
              <ModuleCard {...module} isSelected={false} />
            </div>
          </DialogTrigger>
          <DialogContent
            className="mx-2 max-h-[90vh] w-[95vw] max-w-4xl overflow-hidden p-0 sm:mx-4 sm:w-[90vw] md:w-[85vw] lg:w-[80vw]"
            hideClose
            onOpenAutoFocus={(e) => e.preventDefault()}
          >
            <DialogTitle className="hidden"></DialogTitle>
            <DialogDescription className="sr-only">
              {module.title} Module
            </DialogDescription>
            <div className="h-full max-h-[95vh] overflow-y-auto">
              <ModuleDetails
                module={module}
                onForgeClick={() => handleForgeWithModule(module)}
                showCloseButton
              />
            </div>
          </DialogContent>
        </Dialog>
      ))}
    </div>
  )
}
